export default __webpack_public_path__ + "static/media/elle13.f7afeb1a.webp";